/*eslint-disable*/
import { usePost  } from "./useRequest";

export const parseCv = (document) => {
  const path ="/cvparsing";
  const response = usePost(path, document);
  return response;
};